export default __webpack_public_path__ + "static/media/Love_Stamp.aaa591de.png";